







































































































import { Component, Prop, Vue } from "vue-property-decorator";
import BlogCard from "./blog-card.vue";
import { Loader } from "../forms/parts";

@Component({
  components: {
    BlogCard,
    Loader
  }
})
export default class BlogFilter extends Vue {
  loading: boolean = false;

  params: BlogParams = { per_page: 13, page: 1, blog_categories: [], paginate: 1 };

  @Prop() title?: string;

  @Prop() description?: string;

  @Prop({ default: true }) async?: boolean;

  @Prop({ default: null }) nonAsyncTotal?: number | null;

  @Prop({ default: null }) nonAsyncPages?: number | null;

  articles: Article[] = [];

  firstThree: Article[] = [];

  meta: { total: number; pages: number } = { total: 0, pages: 0 };

  categories: any = [];

  category: number | null = null;

  page = 1;

  search: string = "";

  hash: string = "";

  scrollOnInitialLoad = false;

  async mounted() {
    if (this.async) {
      await this.getCategories();

      this.setHashCategory();

      this.getArticles();
    } else {
      if (this.nonAsyncTotal && this.nonAsyncPages) {
        this.meta = { total: this.nonAsyncTotal, pages: this.nonAsyncPages };
      }

      // set the page from the query string
      const urlParams = new URLSearchParams(window.location.search);
      const page = urlParams.get("page");
      const category = urlParams.get("category");
      //const search = urlParams.get("search");

      if (page) {
        this.page = parseInt(page, 10);
      }
      if (category) {
        this.category = parseInt(category, 10);
      }
      /*if (search) {
        this.search = search;
      }*/
    }
  }

  private getArticles() {
    this.loading = true;
    this.params.page = this.page;

    // @ts-ignore
    axios
      .get("/api/articles", { params: { ...this.params } })
      .then((response: any) => {
        if (response.status === 200) {
          if (this.firstThree.length === 0) {
            this.firstThree = response.data.data.results.slice(0, 3);
          }
          this.articles = response.data.data.results;
          this.meta = response.data.data.meta;
        } else {
          this.articles = [];
          this.meta = { total: 0, pages: 0 };
        }
      })
      .finally(() => {
        this.loading = false;
        this.scrollToFilter();
      });
  }

  private changePage(p: number) {
    if (!this.async) {
      //@ts-ignore
      window.location = `/blog?page=${p}${this.category ? `&category=${this.category}` : ""}`;
    } else {
      this.page = p;
      this.getArticles();
    }
  }

  private scrollToFilter() {
    if (!this.scrollOnInitialLoad) {
      return;
    }

    const el = document.getElementById("blog-filter");

    if (el) {
      el.scrollIntoView({ behavior: "auto" });
    }

    this.scrollOnInitialLoad = false;
  }

  private async getCategories() {
    this.loading = true;
    // @ts-ignore
    const response = await axios.get("/api/categories", { params: { taxonomy: "blog_categories" } });

    this.categories = response.data.data;

    if (this.hash) {
      const match = this.categories.find((c: any) => c.name.toLowerCase() === this.hash.replace("#", "").toLowerCase());

      if (match) {
        this.category = match.term_id;
      }
    }
    this.loading = false;
  }

  private setHashCategory() {
    if (!this.categories) {
      return;
    }

    if (!window.location.hash) {
      this.hash = "";
      return;
    }

    this.hash = window.location.hash;

    const match = this.categories.find((c: any) => c.name.toLowerCase() === this.hash.replace("#", "").toLowerCase());

    if (!match) {
      return;
    }

    this.category = match.term_id;
    this.scrollOnInitialLoad = true;
    this.params.blog_categories = [match.term_id];
  }

  private changeCategory(id: number | null) {
    if (id) {
      this.category = id;
      this.params.blog_categories = [id];
      const match = this.categories.find((c: any) => c.term_id === id);

      //console.log(match);
      if (match) {
        // @ts-ignore
        window.location = `/blog#${match.name.toLowerCase()}`;
      }
    } else {
      this.category = null;
      this.params.blog_categories = [];
    }
    this.getArticles();
  }

  private nextPage() {
    if (!this.async) {
      //@ts-ignore
      window.location = `/blog?page=${this.page + 1}${this.category ? `&category=${this.category}` : ""}`;
    } else {
      this.page++;
      this.getArticles();
    }
  }

  private prevPage() {
    if (!this.async) {
      //@ts-ignore
      window.location = `/blog?page=${this.page - 1}${this.category ? `&category=${this.category}` : ""}`;
    } else {
      this.page--;
      this.getArticles();
    }
  }

  private get paginatedPages(): number[] {
    const pages: number[] = [];

    if (this.page > 2) {
      pages.push(this.page - 2);
    }

    if (this.page > 1) {
      pages.push(this.page - 1);
    }

    pages.push(this.page);

    // @ts-ignore
    if (this.page < parseInt(this.meta.pages, 10) - 1) {
      pages.push(this.page + 1);
    }

    // @ts-ignore
    if (this.page < parseInt(this.meta.pages, 10) - 2) {
      pages.push(this.page + 2);
    }

    return pages;
  }

  private handleSearch() {
    //@ts-ignore
    window.location = `/blog-results?search=${this.search}`;
  }
}
